import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formatPrice, roundToTwoDigit, getSymbolCurrency } from "@/js/currency/currencies.js";
import { listTerms, orderStatus, paymentState, paymentTypesWithCN, getPublicPaymentStateForAdmins, IS_STRIPE_ENABLED } from "@/js/lists.ts";
import OrderPaymentDetailsDialog from "@/components/order/AdminSummarySubs/Payments/OrderPaymentDetailsDialog.vue";
import PaymentChangeStatusDialog from "@/components/payment/PaymentChangeStatusDialog.vue";
import PaymentLinkDrawer from "@/components/payment/AdminPaymentLinkDrawer.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "OrderPaymentList",
  components: {
    OrderPaymentDetailsDialog: OrderPaymentDetailsDialog,
    PaymentChangeStatusDialog: PaymentChangeStatusDialog,
    PaymentLinkDrawer: PaymentLinkDrawer,
    Confirm: Confirm
  },
  props: {
    showTitle: Boolean,
    order: Object,
    inboundDeliveryPayments: Array,
    accountancyReconciliationPayments: Array,
    loggedUserData: Object,
    isAnyActionParentInProgress: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      headers: [{
        text: "Status",
        value: "state",
        align: "left"
      }, {
        text: "Payment method",
        value: "type",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center"
      }],
      payments: [],
      currentItem: null,
      orderPaymentDetailsDialogShown: false,
      paymentLinkDrawerShown: false,
      paymentDialogStatusShown: false,
      listTerms: listTerms,
      paymentState: paymentState,
      paymentTypesWithCN: paymentTypesWithCN,
      IS_STRIPE_ENABLED: IS_STRIPE_ENABLED
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isAnyActionParentInProgress;
    },
    isCancelled: function isCancelled() {
      return this.order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    isPaymentSucceeded: function isPaymentSucceeded() {
      return [paymentState.SUCCEEDED].includes(this.order.payment_state);
    },
    isPaymentProcessing: function isPaymentProcessing() {
      return [paymentState.PROCESSING].includes(this.order.payment_state);
    },
    isShowLaunchPayment: function isShowLaunchPayment() {
      return !this.isPaymentSucceeded && !this.isPaymentProcessing && orderStatus.filter(function (x) {
        return ["VALIDATED", "IN_PREPARATION", "DELIVERY", "CUSTOMS_CLEARANCE", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.order.status);
    },
    totalAmountCurrencyPaid: function totalAmountCurrencyPaid() {
      var amount = 0;
      this.payments.forEach(function (x) {
        amount += x.amount;
      });
      this.inboundDeliveryPayments.forEach(function (x) {
        amount += x.totalAmountCurrency;
      });
      this.accountancyReconciliationPayments.forEach(function (x) {
        amount += x.totalAmountCurrencyAssociations;
      });
      return amount;
    },
    remainingAmount: function remainingAmount() {
      var _this$order$total_amo;
      return roundToTwoDigit(roundToTwoDigit((_this$order$total_amo = this.order.total_amount_currency) !== null && _this$order$total_amo !== void 0 ? _this$order$total_amo : this.order.totalAmountCurrency) - roundToTwoDigit(this.totalAmountCurrencyPaid));
    },
    remainingAmountWithEditedItem: function remainingAmountWithEditedItem() {
      var _this$currentItem$amo, _this$currentItem;
      return this.remainingAmount + roundToTwoDigit((_this$currentItem$amo = (_this$currentItem = this.currentItem) === null || _this$currentItem === void 0 ? void 0 : _this$currentItem.amount) !== null && _this$currentItem$amo !== void 0 ? _this$currentItem$amo : 0);
    }
  },
  created: function created() {
    if (this.order.payments) {
      this.updatePayments(this.order.payments);
    }
  },
  methods: {
    updatePayments: function updatePayments(payments) {
      var _this2 = this;
      this.payments = payments.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          isLaunchingPayment: false,
          isSendPaymentLinkAvailable: _this2.isSendPaymentLinkAvailable(x)
        });
      });
    },
    fetchPayment: function fetchPayment(ack) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this3;
              _context.next = 3;
              return request("/v1/payment/".concat(_this3.currentItem.id), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch payment.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              response = _context.sent;
              if (response) {
                ack(response.data.value);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchPayments: function fetchPayments(ack) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return request("/v1/payment/all?orderId=".concat(_this4.order.id_order), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch payments.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 2:
              response = _context2.sent;
              if (response) {
                _this4.updatePayments(response.data.value);
                _this4.$emit("updateOrder", _this4.payments);
              }
              ack();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    isSendPaymentLinkAvailable: function isSendPaymentLinkAvailable(item) {
      var _item$link;
      return !((_item$link = item.link) !== null && _item$link !== void 0 && _item$link.id) && (!item.state || item.state !== paymentState.SUCCEEDED || item.state !== paymentState.PROCESSING) && this.order.isFullyCalculatedAmounts && this.order.expedition_method > 0 && this.isShowLaunchPayment;
    },
    isPaymentEditable: function isPaymentEditable(item) {
      var _item$link2;
      return !((_item$link2 = item.link) !== null && _item$link2 !== void 0 && _item$link2.id) && (!item.state || item.state !== paymentState.SUCCEEDED) && this.order.status !== orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status;
    },
    addPayment: function addPayment() {
      this.currentItem = null;
      this.orderPaymentDetailsDialogShown = true;
    },
    editPayment: function editPayment(item) {
      if (this.isPaymentEditable(item)) {
        this.currentItem = item;
        this.orderPaymentDetailsDialogShown = true;
      }
    },
    showPaymentStatusDialog: function showPaymentStatusDialog(value) {
      this.paymentDialogStatusShown = value;
    },
    changePaymentStatus: function changePaymentStatus(item) {
      this.currentItem = item;
      this.showPaymentStatusDialog(true);
    },
    updatePaymentStatus: function updatePaymentStatus(status, paymentType, paymentDate, paymentReference, isAttachPaymentToAccRecs) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this5;
              data = _objectSpread({}, _this5.currentItem);
              data.state = status;
              data.type = paymentType;
              data.paymentDate = paymentDate;
              data.reference = paymentReference;
              if (status === _this.paymentState.SUCCEEDED && isAttachPaymentToAccRecs === true) {
                data.isAttachPaymentToAccRecs = isAttachPaymentToAccRecs;
              }
              _context3.prev = 7;
              _context3.next = 10;
              return request("/v1/payment/".concat(_this5.currentItem.id), "put", data, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to change the payment.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 10:
              _this5.showPaymentStatusDialog(false);
              _context3.next = 13;
              return _this5.fetchPayments(function () {});
            case 13:
              _this5.$toasted.show("Payment status changed.", {
                type: "success"
              });
              _context3.next = 18;
              break;
            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](7);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[7, 16]]);
      }))();
    },
    removePayment: function removePayment(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirm;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.$refs.confirm.open("Remove payment", "Are you sure you want to remove this payment?", {
                width: 380,
                color: "red"
              });
            case 2:
              confirm = _context4.sent;
              if (!confirm) {
                _context4.next = 7;
                break;
              }
              _context4.next = 6;
              return request("/v1/payment/".concat(item.id), "delete", null, true, "api", null).catch(function (e) {
                _this.$toasted.show("Unable to remove this payment.", {
                  type: "error"
                });
                throw e;
              });
            case 6:
              _this6.fetchPayments(function () {});
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    isLaunchPaymentAvailable: function isLaunchPaymentAvailable(item) {
      return this.order.isFullyCalculatedAmounts && this.order.expedition_method > 0 && this.isShowLaunchPayment && ![paymentState.SUCCEEDED].includes(item.state) && ![paymentState.PROCESSING].includes(item.state) && !!item.methodId && !!item.type && paymentTypesWithCN.filter(function (x) {
        return x.isDebitable;
      }).map(function (x) {
        return x.id;
      }).includes(item.type);
    },
    launchPayment: function launchPayment(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this7$order$importer;
        var confirm, _this8, tempItem, intervalCount, interval;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.currentItem = item;
              _context5.next = 3;
              return _this7.$refs.confirm.open("Launch stripe payment ?", ((_this7$order$importer = _this7.order.importer) !== null && _this7$order$importer !== void 0 && _this7$order$importer.isPreventingPayment ? "<p class='errorLabel'>WARNING : THE IMPORTER FOR THIS ORDER SHOULD PREVENT PLATFORM PAYMENT.<br />Are you really sure to proceed ?</p>" : "") + "<p>If the payment success, order edition will be blocked. You won't be able to edit any price or quantity. You won't be able to add or remove any product. You won't be able to change shipping method.</p>", {
                width: 480,
                isHtmlMessage: true
              });
            case 3:
              confirm = _context5.sent;
              if (!confirm) {
                _context5.next = 14;
                break;
              }
              _this7.$EventBus.$emit("loading", true);
              item.isLaunchingPayment = true;
              _this8 = _this7;
              _context5.next = 10;
              return request("/v1/payments", "post", {
                paymentIds: [item.id]
              }, true, "api", null).catch(function () {
                _this8.$toasted.show("Unable to launch payment of this order.", {
                  type: "error"
                });
              });
            case 10:
              tempItem = _objectSpread({}, _this7.currentItem);
              intervalCount = 0;
              interval = setInterval(function () {
                intervalCount++;
                _this7.fetchPayment(function (fetched) {
                  if (fetched.state !== tempItem.state || intervalCount >= 5) {
                    clearInterval(interval);
                    item.isLaunchingPayment = false;
                    _this8.currentItem = null;
                    _this8.fetchPayments(function () {});
                  }
                });
              }, 1000);
              _this7.$EventBus.$emit("loading", false);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    createPaymentLink: function createPaymentLink(item) {
      this.currentItem = item;
      this.paymentLinkDrawerShown = true;
    },
    stateStyleClass: function stateStyleClass() {
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, paymentState.SUCCEEDED, "success"), paymentState.PROCESSING, "neutral"), paymentState.ACKNOWLEDGED, "neutral"), paymentState.DEFERRED, "neutral"), paymentState.FAILED, "danger");
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    getPublicPaymentStateForAdmins: getPublicPaymentStateForAdmins
  }
};